import React, { useEffect } from "react";

import useTableQ from "../../../utils/Hooks/useTableQ";
import request from "../../../utils/request.js";

import TableContainerQ from "../../../components/TableBionovaQ/TableContainerQ/TableContainerQ";
import TableHeadQ from "../../../components/TableBionovaQ/TableHeadQ/TableHeadQ";
import TableHeaderCellQ from "../../../components/TableBionovaQ/TableHeaderCellQ/TableHeaderCellQ";
import TableBodyQ from "../../../components/TableBionovaQ/TableBodyQ/TableBodyQ";
import TableRowQ from "../../../components/TableBionovaQ/TableRowQ/TableRowQ";
import TableRowCellQ from "../../../components/TableBionovaQ/TableRowCellQ/TableRowCellQ";
import TablePaginationQ from "../../../components/TableBionovaQ/TablePaginationQ/TablePaginationQ.jsx";
import TruncatedText from "../../../components/TableBionovaQ/TruncatedText/TruncatedText.jsx";
import SpinnerQ from "../../../components/SpinnerQ/SpinnerQ.jsx";
import styles from "./PackageRejectionReasonsTable.module.css";

import Swal from "sweetalert2";
import { toast } from "react-toastify";
import t from "../../../utils/translation.js";

const PackageRejectionReasonsTable = ({
  packagesRR,
  getPackagesRR,
  handleData,
  handleModal,
  handleDetail,
  loading,
}) => {
  const { currentItems, handleSortByColumn } = useTableQ(packagesRR, [
    "title",
    "code",
    "description",
    "colorValue",
  ]);

  const onEdit = (value) => {
    let item = packagesRR.find((prr) => prr.id === value);

    handleData(item);

    handleModal(true);
  };

  const onDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it",
    }).then((result) => {
      if (result.isConfirmed) {
        request()
          .delete(`/api/location?locationId=${id}`)
          .then(() => {
            getPackagesRR();
            toast.success("Your location has been deleted.");
          });
      }
    });
  };


  return (
    <div className={styles.container}>
      <div className={styles.tableContainer}>
        <TableContainerQ>
          <TableHeadQ actions={true}>
            <TableHeaderCellQ
              date={true}
              handleClick={() => handleSortByColumn("code")}
            >
              Code
            </TableHeaderCellQ>
            <TableHeaderCellQ
              date={true}
              handleClick={() => handleSortByColumn("title")}
            >
              Title
            </TableHeaderCellQ>
            

            <TableHeaderCellQ
              handleClick={() => handleSortByColumn("description")}
            >
              Description
            </TableHeaderCellQ>
            <TableHeaderCellQ
              handleClick={() => handleSortByColumn("ColorValue")}
            >
              Color
            </TableHeaderCellQ>
          </TableHeadQ>
          {loading ? (
            <div className="spinnerContainer">
              <SpinnerQ />
            </div>
          ) : (
            <TableBodyQ loading={loading}>
              {currentItems.map((prr) => (
                <TableRowQ
                  key={prr.id}
                  actions={true}
                  edit={true}
                  detail={true}
                  deleteRow={true}
                  onEdit={() => onEdit(prr.id)}
                  onDelete={() => onDelete(prr.id)}
                  doubleClick={() => onEdit(prr.id)}
                  onDetail={() => handleDetail(prr)}
                >
                  <TableRowCellQ date={true}>
                    <TruncatedText text={prr.title} maxLength={25} />
                  </TableRowCellQ>
                  <TableRowCellQ date={true}>
                    <TruncatedText text={prr.code} maxLength={25} />
                  </TableRowCellQ>

                  <TableRowCellQ>
                    <TruncatedText text={prr.description} maxLength={25} />
                  </TableRowCellQ>
                  <TableRowCellQ>
                    <div
                      className={styles.colorOption}
                      style={{ backgroundColor: prr.colorValue }}
                    />
                  </TableRowCellQ>
                </TableRowQ>
              ))}
            </TableBodyQ>
          )}
        </TableContainerQ>
      </div>
    </div>
  );
};

export default PackageRejectionReasonsTable;
